import React from "react";
import "./BusinessHero.css";
import image from "../businessassets/hero.png";

export default function BusinessHero() {
  return (
    <div id="business-hero" className="outsourcemainclass">
      <h2 className="heading">DevOps Monitoring & Observability Services</h2>
      <p className="subheading">
   Gain complete visibility into your applications and infrastructure with BastionEx’s DevOps Monitoring & Observability services. We help organizations proactively monitor systems, analyze performance, and gain actionable insights to ensure reliability, availability, and optimal user experiences across environments.
      </p>
     <div className="image">
        <img src={image} alt="error" />
      </div>
    </div>
  );
}
